import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex flex-column w-100 h-100" }
const _hoisted_2 = {
  key: 0,
  class: "avatar mb-2"
}
const _hoisted_3 = { class: "name text-color" }
const _hoisted_4 = { class: "status text-color" }
const _hoisted_5 = { class: "mt-2 status-icons" }
const _hoisted_6 = {
  key: 1,
  style: {"visibility":"hidden !important"}
}

import WebRtcVideo from "~/core-ui/vue/chat/webrtc/WebRtcVideo.vue";
import {computed, ref} from "vue";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

import WebRtcCallUserOpenApiModel = CometOperatorApplication.WebRtcCallUserOpenApiModel;

const __default__ = {
    name: "WebRtcUserDisplay"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    user: {},
    call: {}
  },
  setup(__props: any) {

let props = __props;

let cover = ref(true);

let connection = computed(() => props.call.getRtcPeerConnectionByPairId(props.user.pair?.id));

let statusDescr = computed(() => {
    let status = props.user.pair?.status.descr;
    if (!status) {
        if (connection.value) {
            status = "Неизвестный статус"
        } else {
            status = "Ожидаем, пока пользователь примет звонок";
        }
    }
    return status;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-center",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(cover) //@ts-ignore
 ? cover.value = !_unref(cover) : cover = !_unref(cover)))
  }, [
    (_unref(connection) && _unref(connection).getRemoteStream() && (__props.user.isScreenEnabled || __props.user.isWebCamEnabled))
      ? (_openBlock(), _createBlock(WebRtcVideo, {
          key: 0,
          stream: _unref(connection).getRemoteStream(),
          "web-rtc-media-stream": __props.call.webRtcMediaStream,
          "video-enabled": __props.user.isScreenEnabled || __props.user.isWebCamEnabled,
          "audio-enabled": __props.user.isAudioEnabled,
          class: _normalizeClass({'h-100': true, cover: _unref(cover) && __props.call.getCallData()?.users.length > 2})
        }, {
          noaudio: _withCtx(() => [
            _renderSlot(_ctx.$slots, "noaudio")
          ]),
          novideo: _withCtx(() => [
            _renderSlot(_ctx.$slots, "novideo")
          ]),
          _: 3
        }, 8, ["stream", "web-rtc-media-stream", "video-enabled", "audio-enabled", "class"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(connection) && _unref(connection).getRemoteStream())
            ? (_openBlock(), _createBlock(WebRtcVideo, {
                key: 0,
                "web-rtc-media-stream": __props.call.webRtcMediaStream,
                stream: _unref(connection).getRemoteStream(),
                style: {"display":"none !important"},
                "video-enabled": false,
                "audio-enabled": ""
              }, null, 8, ["web-rtc-media-stream", "stream"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
            _createElementVNode("div", null, [
              (__props.user.avatar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "avatar", _normalizeProps(_guardReactiveProps({avatar: __props.user.avatar})))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.user.descr), 1),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_unref(statusDescr)) + " ", 1),
                _createElementVNode("div", _hoisted_5, [
                  (_unref(connection)?.getRemoteStream())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!__props.user.isAudioEnabled)
                          ? _renderSlot(_ctx.$slots, "noaudio", { key: 0 })
                          : _createCommentVNode("", true),
                        (!__props.user.isWebCamEnabled && !__props.user.isScreenEnabled)
                          ? _renderSlot(_ctx.$slots, "novideo", { key: 1 })
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!_unref(connection)?.getRemoteStream() || (__props.user.isAudioEnabled && (__props.user.isWebCamEnabled || __props.user.isScreenEnabled)))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "noaudio")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-fill" }, null, -1))
          ])
        ], 64))
  ]))
}
}

})